import type { IFilterOptions, IOptions } from "@fluidattacks/design";

const formatChecks = (options?: readonly IOptions[]): string | undefined => {
  if (!options || options.length === 0) {
    return undefined;
  }

  const selectedOptions = options
    .filter((option): boolean => option.checked ?? false)
    .map((option): string => option.value);

  if (selectedOptions.length === 0) return undefined;

  const formattedCheckValues = selectedOptions.join(", ");

  return formattedCheckValues;
};

const getFilter = <T extends object>(
  filters: readonly IFilterOptions<T>[],
  key: keyof T,
): IFilterOptions<T> | undefined =>
  filters.find((filter): boolean => filter.key === key);

export { formatChecks, getFilter };
